import styled from "styled-components";
import { BLUE, LIGHT_BLUE, NEAR_WHITE } from "../../config";

export const TitleContainer = styled.div`
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 900;
  font-size: 20px;
  line-height: 28px;
  color: ${LIGHT_BLUE};
  transition: 0.2s ease;
`;

export const GoBack = styled.div`
  width: 2rem;

  svg {
    cursor: pointer;

    &:hover {
      color: ${LIGHT_BLUE};
    }

    &:active {
      color: ${BLUE};
    }
  }
`;

export const PageContent = styled.div`
  padding-right: 2rem;
  padding-left: 2rem;
  height: calc(100% - 4rem);
  overflow: auto;
`;

export const LastUpdate = styled.div`
  margin-left: auto;
  font-size: 14px;
  color: ${NEAR_WHITE};
  font-weight: 400;
  display: flex;
  align-items: center;
`;
